import SimpleElementBuilder from '@/Builder/SimpleElementBuilder';
import EventHelper from '@/Utility/EventHelper';
import Utilities from '@/Utility/Utilities';

export default class SimpleLinkBuilder extends SimpleElementBuilder {

    private onClick: (openInNewWindow: boolean) => void;
    private caption: string;

    public constructor() {
        super();
    }

    public withOnClick(onClick: (openInNewWindow: boolean) => void): this {
        this.onClick = onClick;
        return this;
    }

    public withCaption(caption: string): this {
        this.caption = caption;
        return this;
    }

    public buildAndGetElement(): HTMLElement {
        const element = this.element || document.createElement('a');
        // controlName-binding could be used, but:
        // the simple-link-builder should be very fast
        // so we set the className manually
        element.classList.add('c-link');
        EventHelper.bindClickEvent(element, this.onClick);
        if (!Utilities.isNullOrUndefinedOrBlank(this.caption))
            element.innerText = this.caption;
        return element;
    }
}